// Clustering country options — kept in lock-step with the backend's
// COUNTRY_MAP in services/clustering/normalize.py. The backend resolves by
// full country name (case-insensitive), so `value` is the exact backend key.

export interface ClusteringCountryOption {
  value: string;
  label: string;
  flag: string;
}

export const CLUSTERING_COUNTRY_OPTIONS: ClusteringCountryOption[] = [
  { value: 'United States',  label: 'United States',  flag: '🇺🇸' },
  { value: 'United Kingdom', label: 'United Kingdom', flag: '🇬🇧' },
  { value: 'Germany',        label: 'Germany',        flag: '🇩🇪' },
  { value: 'France',         label: 'France',         flag: '🇫🇷' },
  { value: 'Spain',          label: 'Spain',          flag: '🇪🇸' },
  { value: 'Italy',          label: 'Italy',          flag: '🇮🇹' },
  { value: 'Netherlands',    label: 'Netherlands',    flag: '🇳🇱' },
  { value: 'Poland',         label: 'Poland',         flag: '🇵🇱' },
  { value: 'Czechia',        label: 'Czechia',        flag: '🇨🇿' },
  { value: 'Canada',         label: 'Canada',         flag: '🇨🇦' },
  { value: 'Australia',      label: 'Australia',      flag: '🇦🇺' },
  { value: 'India',          label: 'India',          flag: '🇮🇳' },
  { value: 'Brazil',          label: 'Brazil',          flag: '🇧🇷' },
  { value: 'Japan',          label: 'Japan',          flag: '🇯🇵' },
];

export const DEFAULT_CLUSTERING_COUNTRY = 'United States';
